import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const TeamBillingDetails = lazy(() => import('./TeamBillingDetails'))

class TeamBillingDetailsWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return []
  }

  override render() {
    return (
      <RootProviders>
        <TeamBillingDetails />
      </RootProviders>
    )
  }
}

customElements.define('team-billing-details', TeamBillingDetailsWebComponent)
